import AddIcon from '@mui/icons-material/Add';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { Button, CircularProgress, Divider, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { ModalAlert } from '../../../components/modal';
import BasicTable from '../../../components/table';
import { TableBar } from '../../../components/table/styles';
import { api } from '../../../services/axios';
import { AddModal } from './styles';

import { encode } from 'base-64';
import Modal from "react-modal";
import { ModalAlertDiv } from '../../../components/modal/style';
import ModalDelete from '../../../components/modal/modalDelete';

const defaultForm = {
  company: '',
  adress: '',
  city: '',
  country: '',
  language: 'es'
}

const defaultError = {
  company: false,
  adress: false,
  city: false,
  country: false,
  language: false,
}

const Generator = () => {
  const url = "core/ajax/providers"
  const headers = [
    { label: 'Id', value: 'IdCompany' },
    { label: 'Name', value: 'Company' },
    { label: 'CreateDate', value: 'CreateDate' },
    { label: 'Active', value: 'Active' },
    { label: 'Actions', value: 'Actions' },
  ]

  const [showModal, setShowModal] = useState(false)
  const [rows, setRows] = useState({ default: [], filter: [] })
  const [isValidate, setIsValidate] = useState(false)
  const [form, setForm] = useState(defaultForm);

  const [alert, setAlert] = useState({ msg: '', status: '' });
  const [showAlert, setShowAlert] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [id, setId] = useState();
  const [isCreate, setIsCreate] = useState(true);


  useEffect(() => {
    listUpdate()
  }, [])

  const listUpdate = () => {
    const url = "core/ajax/providers"
    api.post(url, {
      type: 'list',
    })
      .then(function (res) {
        setRows({
          default: res.data.map((e) => {
            return {
              ...e,
              IdCompany: Number(e.IdCompany),
            }
          }), filter: res.data.map((e) => {
            return {
              ...e,
              IdCompany: Number(e.IdCompany),
            }
          })
        })
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const validation = () => {
    if (form.name === '' || form.adress === ''
      || form.city === '' || form.country === ''
      || form.language === '') {
      setIsValidate(true)
      return false
    } else {
      return true
    }
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      // height: "90%",
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',

    }
  };


  const updateForm = (row) => {
    setForm({
      company: row.Company,
      adress: row.Address,
      city: row.City,
      country: row.Country,
      language: row.Language,
      chatUrl: row.ChatUrl,
      type: 'Phone'
    })
    setIsCreate(false)
    setShowModal(true)
    setId(row.IdCompany)
  }

  const confirmUpdateForm = () => {
    api.post(url, {
      type: 'update',
      IdCompany: id,
      Company: form.company,
      Address: form.adress,
      City: form.city,
      Country: form.country,
      Language: form.language,
      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const createGenerator = () => {
    api.post(url, {
      type: 'insert',
      Company: form.company,
      Address: form.adress,
      City: form.city,
      Country: form.country,
      Language: form.language,
      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const onDelete = (id) => {
    setId(id)
    setShowDelete(!showDelete)
    setAlert({ status: "go" })
  }

  const confirmDelete = () => {
    api.post(url, {
      type: 'delete',
      IdCompany: id,
      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        setAlert({ msg: 'Ocorreu um erro', status: 'error' })
        console.log(error);
      });
  }

  const handleActive = (id, active) => {
    api.post(url, {
      type: 'activeProvider',
      IdCompany: id,
      active: active ? 1 : 0,
      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        setAlert({ msg: 'Ocorreu um erro', status: 'error' })
        console.log(error);
      });
  }

  const inputFilter = (e) => {
    const filter = rows.default.filter((row) => {
      return row.Company.toLowerCase().includes(e.target.value.toLowerCase()) ||
        row.IdCompany.toString().includes(e.target.value) ||
        row.CreateDate.includes(e.target.value)
    });
    setRows({ ...rows, filter })
  }

  return (
    <TableBar>

      <h1>List Generators</h1>
      <div className='buttons'>
        <TextField
          label="Search"
          variant="outlined"
          size='small'
          onChange={inputFilter}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchOutlinedIcon />
              </InputAdornment>
            ),
          }}
        />

        <Button startIcon={<AddIcon />} onClick={() => {
          setShowModal(!showModal)
          setIsCreate(true)
        }} variant="contained">Add</Button>
      </div>
      <BasicTable type={'generators'} headers={headers} rowsProps={rows.filter} updateForm={updateForm} onDelete={onDelete} handleActive={handleActive} />
      <Modal isOpen={showModal}
        onRequestClose={() => {
          setShowModal(false)
          setForm(defaultForm)
          setIsValidate(false)
        }}
        style={customStyles}
        ariaHideApp={false}>
        <AddModal>
          <h1>Generator</h1>

          <Divider className='divider' variant="middle" />
          <TextField margin="dense" label="Company" variant="outlined"
            helperText={form.company === '' && isValidate ? "Incorrect entry." : ""}
            error={form.company === '' && isValidate}
            value={form.company}
            onChange={(e) => {
              setForm({
                ...form,
                company: e.target.value
              })
            }} />
          <TextField margin="dense" label="Adress" variant="outlined"
            helperText={form.adress === '' && isValidate ? "Incorrect entry." : ""}
            error={form.adress === '' && isValidate}
            value={form.adress}
            onChange={(e) => {
              setForm({
                ...form,
                adress: e.target.value
              })
            }} />
          <TextField margin="dense" label="City" variant="outlined"
            helperText={form.city === '' && isValidate ? "Incorrect entry." : ""}
            error={form.city === '' && isValidate}
            value={form.city}
            onChange={(e) => {
              setForm({
                ...form,
                city: e.target.value
              })
            }} />
          <TextField margin="dense" label="Country" variant="outlined"
            helperText={form.country === '' && isValidate ? "Incorrect entry." : ""}
            error={form.country === '' && isValidate}
            value={form.country}
            onChange={(e) => {
              setForm({
                ...form,
                country: e.target.value
              })
            }} />


          <FormControl sx={{ m: '1rem 0', minWidth: 120 }}>
            <InputLabel id="demo-simple-select-helper-label">Language</InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={form.language}
              label="Language"
              onChange={(e) => {
                setForm({
                  ...form,
                  language: e.target.value
                })
              }}
            >
              <MenuItem value={'es'}>ES</MenuItem>
              <MenuItem value={'en'}>EN</MenuItem>
              <MenuItem value={'pt'}>PT</MenuItem>
            </Select>
            {/* <FormHelperText>With label + helper text</FormHelperText> */}
          </FormControl>
          <Button onClick={() => {
            if (validation()) {
              isCreate ? createGenerator() : confirmUpdateForm()
              setShowAlert(!showAlert)
            } else {
              console.log(form);
            }
          }} variant="contained">{isCreate ? 'Create' : 'Update'}</Button>
        </AddModal>
      </Modal>

      {/* Modal de Alerta */}
      <ModalAlert showModal={showAlert} onClose={() => {
        setShowAlert(!showAlert)
        setAlert({ msg: '', status: undefined })
      }} onClickOutside={false}>
        {alert.status === undefined ?
          <ModalAlertDiv>
            <CircularProgress />
            <h1>Creating generator...</h1>
            <p>Please, wait...</p>
          </ModalAlertDiv>
          : alert.status === 'ok' ?
            <ModalAlertDiv>
              <CheckCircleOutlineOutlinedIcon color={"success"} style={{ fontSize: "4rem" }} />
              <h1>Success!</h1>

              <Button onClick={() => {
                setShowAlert(false)
              }} variant="contained">Ok</Button>
            </ModalAlertDiv>
            :
            <ModalAlertDiv>
              <h1>{alert.msg}</h1>
              <h3>:&#40;	</h3>
              <h3>{alert.msg}</h3>

            </ModalAlertDiv>}
      </ModalAlert>

      {/* Modal de delete */}
      <ModalDelete type={'generator'} showDelete={showDelete} alert={alert} setShowDelete={setShowDelete} setAlert={setAlert} confirmDelete={confirmDelete} />
    </TableBar >
  );
}

export default Generator;